module.exports = __webpack_public_path__ + "static/img/content-writing.a1bbe624.jpg";